import { useNavigate, useLocation } from 'react-router-dom';
import { Upload, Download, ChevronRight } from 'lucide-react';
import { palette, admin, transition, fontFamily } from '../../../styles/tokens';
import { SETTINGS_SECTIONS } from '../config/settingsConfig';

// Build a map from route → title for breadcrumbs
const ROUTE_TITLES: Record<string, string> = {};
for (const section of SETTINGS_SECTIONS) {
  for (const card of section.cards) {
    ROUTE_TITLES[card.route] = card.title;
  }
}
ROUTE_TITLES['/settings/import'] = 'Import config';
ROUTE_TITLES['/settings/export'] = 'Export config';

export function SettingsTopBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const isHub = location.pathname === '/settings';
  const subTitle = ROUTE_TITLES[location.pathname];

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 20,
      fontFamily,
    }}>
      {/* Breadcrumb */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        {isHub ? (
          <div style={{ fontSize: 24, fontWeight: 700, color: admin.header, letterSpacing: '-0.5px' }}>
            Settings
          </div>
        ) : (
          <>
            <button
              onClick={() => navigate('/settings')}
              style={{
                fontSize: 14,
                fontWeight: 500,
                color: palette.accent,
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontFamily,
                padding: 0,
              }}
            >
              Settings
            </button>
            <ChevronRight size={14} color={palette.g400} />
            <span style={{ fontSize: 14, fontWeight: 500, color: palette.g800 }}>
              {subTitle ?? 'Settings'}
            </span>
          </>
        )}
      </div>

      {/* Import/Export buttons — only on hub */}
      {isHub && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <button
            onClick={() => navigate('/settings/import')}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              padding: '7px 14px',
              borderRadius: 8,
              border: `1px solid ${admin.border}`,
              background: palette.white,
              fontSize: 13,
              fontWeight: 500,
              color: palette.g600,
              cursor: 'pointer',
              fontFamily,
              transition: `border-color ${transition.fast}`,
            }}
          >
            <Upload size={14} strokeWidth={1.8} />
            Import
          </button>
          <button
            onClick={() => navigate('/settings/export')}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              padding: '7px 14px',
              borderRadius: 8,
              border: 'none',
              background: palette.accent,
              fontSize: 13,
              fontWeight: 500,
              color: palette.white,
              cursor: 'pointer',
              fontFamily,
              transition: `background ${transition.fast}`,
            }}
          >
            <Download size={14} strokeWidth={1.8} />
            Export
          </button>
        </div>
      )}
    </div>
  );
}
